import { useRef, useEffect } from 'react'
import { positionValues } from 'react-custom-scrollbars'
import { DotProps } from 'react-multi-carousel'
import { common } from '@ocean/ui'
import { Wrapper } from './GridCarouselControl.styled'

const { Scrollbars } = common

type GridCarouselControlProps = DotProps & {
  carouselRef: React.RefObject<any>
}

const GridCarouselControl: React.FC<GridCarouselControlProps> = ({
  carouselState,
  carouselRef,
}) => {
  const { itemWidth = 0, totalItems = 0, transform = 0, currentSlide = 0 } = carouselState || {}
  const carousel = carouselRef.current
  const scrollbarsRef = useRef(null)

  useEffect(() => {
    let mounted = true

    function resetMounted() {
      mounted = false
    }

    const scrollbars: any = scrollbarsRef.current
    if (scrollbars && mounted) {
      scrollbars.scrollLeft(Math.abs(transform))
    }

    return resetMounted
  }, [currentSlide]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleScroll(values: positionValues) {
    const { scrollLeft } = values
    const nextSlide = Math.round(scrollLeft / itemWidth)

    carousel.setState({
      transform: -scrollLeft,
      currentSlide: nextSlide,
    })
  }

  return (
    <Wrapper data-test='GridCarouselControl'>
      <Scrollbars ref={scrollbarsRef} sticky autoHeight={false} onScrollFrame={handleScroll}>
        <div style={{ width: totalItems * itemWidth, height: 1 }} />
      </Scrollbars>
    </Wrapper>
  )
}

export default GridCarouselControl
